module.exports = __webpack_public_path__ + "media/images/arrow_left-603f1e277ba9d06bf13f5e6b4ae0b78f.png";